import React from 'react'
import { Card, CardHeader, CardContent, Button, Label } from '@/shared/ui'
import { CountrySelect } from '@/shared/ui/CountrySelect'
import { useToast } from '@/shared/ui/Toast'
import { useProfileForm } from '@/modules/profile/hooks/useProfileForm'

export default function UserRegionSettingsCard() {
  const { profile, saveBasic, loading, saving } = useProfileForm() as any
  const { add: toast } = useToast()
  const [country, setCountry] = React.useState<string>('BR')

  React.useEffect(() => {
    const code = (profile?.country || '').toString().trim().toUpperCase()
    setCountry(code || 'BR')
  }, [profile?.country])

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    const ok = await saveBasic({ country: country || null })
    if (ok) {
      toast({
        title: 'Localização salva',
        description: 'Seu país foi atualizado.',
        variant: 'success',
      })
    } else {
      toast({
        title: 'Falha ao salvar',
        description: 'Não foi possível atualizar sua localização.',
        variant: 'error',
      })
    }
  }

  return (
    <Card>
      <CardHeader className="text-sm font-medium">Localização e horário</CardHeader>
      <CardContent>
        <form className="space-y-4" onSubmit={onSubmit}>
          <div className="space-y-1.5">
            <Label>País</Label>
            <CountrySelect
              value={country}
              onChange={(code) => setCountry(code)}
              includeDial
              className="h-12"
            />
          </div>
          <p className="text-xs text-foreground/70">
            Usamos seu país para ajustar o formato de telefone e exibir datas e horários no seu fuso horário, quando disponível.
          </p>
          <Button type="submit" disabled={saving || loading} className="min-w-28">
            Salvar
          </Button>
        </form>
      </CardContent>
    </Card>
  )
}

